var E={NAV:"nav",SEARCH:"jssearch",ORG_SEARCH:"search",CATEGORY:"cl",TAG:"kp",LEARNING_CENTER_CAT:"catTab",LEARNING_CENTER_JD:"jdTab",FEATURED_INSTITUTES:"featuredInst",WEB_SIDEBAR:"webnotifsidebar"};export{E as REFCODES};
//# sourceMappingURL=refCodes.js.map
